import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '../stores/auth.store';
import { PermissionService } from '../services/permission.service';
import { PERMISSION_IDS } from '../constants/permission.const';
import { APP_ROUTES } from '../constants/app-routes.const';

/**
 * Higher-order Function (Factory) tạo Guard kiểm tra quyền truy cập theo ID.
 * Đặc biệt xử lý trường hợp F5 (Refresh) bằng cách tải lại thông tin User & Menu.
 *
 * @param permissionId ID định danh của màn hình/tính năng (Ví dụ: SCR_USER_MGT)
 */
export function permissionGuard(permissionId: string): CanActivateFn {
  return async () => {
    const authStore = inject(AuthStore);
    const permissionService = inject(PermissionService);
    const router = inject(Router);

    // 1. Kiểm tra Token (An toàn bổ sung, dù đã có AuthGuard)
    if (!authStore.isAuthenticated()) {
      return router.parseUrl('/' + APP_ROUTES.LOGIN);
    }

    // 2. Xử lý F5 / Refresh (Nếu chưa load thông tin User/Menu)
    if (!authStore.isLoaded()) {
      try {
        console.log(
          `[PermissionGuard] Refresh detected. Loading permissions for: ${permissionId}`,
        );
        await permissionService.loadUserAndPermissions();
      } catch (error) {
        console.error(
          '[PermissionGuard] Failed to load permissions on refresh:',
          error,
        );
        return router.parseUrl('/' + APP_ROUTES.LOGIN);
      }
    }

    // 3. Nếu là chế độ nạp dữ liệu khởi tạo (Landing Page)
    if (permissionId === PERMISSION_IDS.INIT) {
      return true;
    }

    // 4. Kiểm tra quyền truy cập dựa trên ID
    const hasAccess = permissionService.hasMenuAccess(permissionId);
    if (hasAccess) {
      return true;
    }

    // 5. Nếu không có quyền, chuyển hướng về trang 403
    console.warn(`[PermissionGuard] Access denied for ID: ${permissionId}`);
    return router.parseUrl('/' + APP_ROUTES.FORBIDDEN);
  };
}
